<div class="skz-input-wrapper" [class.compact]="compact()">
  @if (prefixIcon()) {
    <svg
      class="skz-input__prefix"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      @switch (prefixIcon()) {
        @case ('search') {
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        }
        @case ('filter') {
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        }
        @case ('lock') {
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        }
        @case ('at') {
          <circle cx="12" cy="12" r="4" />
          <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" />
        }
      }
    </svg>
  }
  @if (prefixText()) {
    <span class="skz-input__prefix-text">{{ prefixText() }}</span>
  }
  <input
    class="skz-input__field"
    [class.compact]="compact()"
    [id]="inputId"
    [type]="type()"
    [placeholder]="placeholder()"
    [value]="_value"
    [disabled]="_disabled"
    [attr.autocomplete]="autocomplete()"
    [attr.aria-label]="ariaLabel() || placeholder() || null"
    [attr.aria-invalid]="isInvalid"
    (input)="onInput($event)"
  />
  @if (suffixText()) {
    <span class="skz-input__suffix-text">{{ suffixText() }}</span>
  }
</div>
